import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost/backend';

const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Función helper para construir URLs de imágenes
export const getImageUrl = (url) => {
  if (!url) return '';
  // Si ya es una URL absoluta, retornarla tal cual
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // Si es una URL relativa que empieza con /backend, construir la URL completa
  if (url.startsWith('/backend/')) {
    const base = baseURL.replace('/backend', '');
    return base + url;
  }
  // Si es una URL relativa sin /backend, agregar el prefijo
  if (url.startsWith('/')) {
    const base = baseURL.replace('/backend', '');
    return base + '/backend' + url;
  }
  // Si no tiene prefijo, agregar /backend/uploads/
  return baseURL.replace('/backend', '') + '/backend/uploads/servicios/' + url;
};

export default api;

// Interceptor para manejar respuestas
api.interceptors.response.use(
  (response) => {
    // Verificar que la respuesta sea JSON válido
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes('application/json')) {
      return response;
    }
    // Si no es JSON, intentar parsear de todas formas
    try {
      if (typeof response.data === 'string') {
        response.data = JSON.parse(response.data);
      }
      return response;
    } catch (e) {
      console.error('Error: La respuesta del servidor no es JSON válido', response.data);
      return Promise.reject(new Error('Respuesta del servidor no es válida'));
    }
  },
  (error) => {
    // Si el error tiene respuesta pero no es JSON
    if (error.response) {
      const contentType = error.response.headers['content-type'];
      if (!contentType || !contentType.includes('application/json')) {
        console.error('Error: El servidor devolvió HTML en lugar de JSON', error.response.data);
        // Intentar parsear si es posible
        if (typeof error.response.data === 'string') {
          try {
            error.response.data = JSON.parse(error.response.data);
          } catch (e) {
            error.response.data = { message: 'Error del servidor: respuesta no válida' };
          }
        }
      }
    }
    
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

